import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import {
  AddOnName,
  AddOnType,
  IItemToRequest,
  MyPurchaseForm,
} from 'src/app/shared/models/app-models';
import { AddOn } from 'src/app/shared/models/database-models';

@Component({
  selector: 'app-item-add-on',
  templateUrl: './item-add-on.component.html',
  styleUrls: ['./item-add-on.component.scss'],
})
export class ItemAddOnComponent implements OnInit, OnDestroy {
  @Input() isReadOnly: boolean = false;
  @Input() priceQuantity: number = 0;
  @Output() getAddOnData = new EventEmitter();
  destroy$: Subject<boolean> = new Subject<boolean>();
  mode: string = 'add';
  itemNo: number = 0;
  form: IItemToRequest[] = [];
  ExtendedWarranty: AddOn = {
    AddOnTypeId: AddOnType.ExtendedWarranty,
    ItemAddOnId: null,
    PurchaseItemId: null,
    isDeleted: true,
    Quantity: 1,
    DurationYears: 0,
    DurationMonths: 0,
    UnitOfMeasurements: null,
    CurrencyCode: null,
    EstimatedUnitPrice: null,
    MPDocumentNumber: null,
    Strikethrough: false
  };
  Maintenance: AddOn = {
    AddOnTypeId: AddOnType.Maintenance,
    ItemAddOnId: null,
    PurchaseItemId: null,
    isDeleted: true,
    Quantity: 1,
    DurationYears: 0,
    DurationMonths: 0,
    UnitOfMeasurements: null,
    CurrencyCode: null,
    EstimatedUnitPrice: null,
    MPDocumentNumber: null,
    Strikethrough: false
  };
  OptionToPurchase: AddOn = {
    AddOnTypeId: AddOnType.OptionToPurchase,
    ItemAddOnId: null,
    PurchaseItemId: null,
    isDeleted: true,
    DurationYears: 0,
    DurationMonths: 0,
    Quantity: 1,
    UnitOfMeasurements: null,
    CurrencyCode: null,
    EstimatedUnitPrice: null,
    MPDocumentNumber: null,
    Strikethrough: false
  };

  constructor(
    private store: Store<{ form: MyPurchaseForm }>,
    private route: ActivatedRoute
  ) {
    this.mode = this.route.snapshot.params['itemNo'] ? 'edit' : 'add';
    if (this.mode === 'edit') {
      this.itemNo = this.route.snapshot.params['itemNo'];
    }
  }

  async ngOnInit() {
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: MyPurchaseForm) => {
        this.form = form.ItemList;
        if (this.mode == 'edit' && this.form.length !== 0) {
          const formEdited = this.form[this.itemNo - 1];
          const addOnEdited = formEdited?.AddOnFeature?.filter(x => !x.isDeleted && !x.Strikethrough) || [];
          this.tranformAddOn(addOnEdited);
        }
      });
  }

  tranformAddOn(data: AddOn[]) {
    data.forEach((item: AddOn) => {
      let isDeleted = !!item.isDeleted
      this[this.handleAddOnTypeId(item.AddOnTypeId)] = {
        ...item,
        Strikethrough: item.Strikethrough ?? isDeleted,
        isDeleted: isDeleted,
        Quantity: item.Quantity ? item.Quantity : null,
        DurationYears: item.DurationYears ? item.DurationYears : 0,
        DurationMonths: item.DurationMonths ? item.DurationMonths : 0,
      };
    });
  }
  getFormData(event: AddOn) {
    this[this.handleAddOnTypeId(event.AddOnTypeId)] = event;
    this.tranformData(event);
  }

  handleAddOnTypeId(type: AddOnType) {
    let result: AddOnName = AddOnName.ExtendedWarranty;
    if (type === AddOnType.Maintenance) {
      result = AddOnName.Maintenance;
    } else if (type === AddOnType.OptionToPurchase) {
      result = AddOnName.OptionToPurchase;
    }
    return result;
  }

  tranformData(event: AddOn) {
    const newData: AddOn = {
      ...event,
      Quantity: event.Quantity ? event.Quantity : null,
      DurationMonths: event.DurationMonths ? event.DurationMonths : 0,
      DurationYears: event.DurationYears ? event.DurationYears : 0,
    };
    this.getAddOnData.emit(newData);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
